import { Modal } from 'antd';
import { resolveAppMediaUrl } from '../utils/resolveAppMediaUrl';
import type { WeworkServiceCardView } from './WeworkServiceType';
import './WeworkServiceModal.css';

export type WeworkServiceModalProps = {
  open: boolean;
  title: string;
  content: string;
  card: WeworkServiceCardView | null;
  /** 空间首页弹框专用布局 */
  variant?: 'home' | 'default';
  showDismiss?: boolean;
  onClose: () => void;
  onDismissForever?: () => void;
};

export function WeworkServiceModal(props: WeworkServiceModalProps): JSX.Element {
  const { open, title, content, card, variant = 'default', showDismiss, onClose, onDismissForever } =
    props;
  const qrSrc = resolveAppMediaUrl(card?.qrcodeUrl?.trim() || null);
  const isHome = variant === 'home';

  return (
    <Modal
      open={open}
      title={title}
      footer={null}
      onCancel={onClose}
      destroyOnClose
      className={isHome ? 'wework-modal wework-modal--home' : 'wework-modal'}
      width={isHome ? 600 : 420}
    >
      <div className="wework-modal__body">
        {content ? <p className="wework-modal__content">{content}</p> : null}
        {qrSrc ? (
          <div className="wework-modal__qr-wrap">
            <img src={qrSrc} alt="" className="wework-modal__qr" />
            {card?.nickname?.trim() ? (
              <p className="wework-modal__nickname">{card.nickname.trim()}</p>
            ) : null}
          </div>
        ) : null}
        {showDismiss ? (
          <div className="wework-modal__foot">
            <button type="button" className="wework-modal__dismiss" onClick={onDismissForever}>
              下次不再提示
            </button>
          </div>
        ) : null}
      </div>
    </Modal>
  );
}
